import React from 'react'
import './Card.css'

function Card({ title, subTitle, description, icon, onUpdateClick }) {

    return (
        <div className={"card card-block card-input h-100"}>
            <div className="row g-0">
                <div className="col-md-3 center-parent stepIcon">
                    {icon}
                </div>
                <div className={onUpdateClick != null ? "col-md-7" : "col-md-9"} style={{display: 'flex', alignItems: "center"}}>
                    <div className="card-body">
                        <h5 className="card-title">{title}</h5>
                        <p className="card-text">{subTitle}</p>
                        <p className="card-text">{description}</p>
                    </div>
                </div>
                {onUpdateClick != null &&
                    <div className="col-md-2 card-button">
                        <button type="button" className="btn btn-primary bowl-btn" onClick={onUpdateClick}>Update</button>
                    </div>
                }
            </div>
        </div>
    )
}

export default Card
